<template>
  <div id="container">
    <div class="product-status">
      <el-form class="search-style">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item>
              <div style="display: flex;">
                <span style="width: 120px;">型号/订货号：</span>
                <el-select
                 v-el-select-loadmore="loadmore"
                  v-model="queryParams.value"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="remoteMethod"
                  :loading="loading"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.proModel || item.proOrdernum"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button
              type="primary"
              @click="onSearch"
            >搜索
            </el-button>
            <el-button
              @click="onReset"
              plain
            >重置
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="nosearch">
        <div v-if="quoteCollectTable.length">
          <div
            class="box-table"
            :style="{height:tableHeight+'px'}"
          >
            <div
              v-if="quoteCollectTable[0]"
              class="pb20 wft"
            >
              <span>当前查询产品 </span>
              <span>品牌：{{quoteCollectTable[0].brandName}}</span>
              <span>系列：{{quoteCollectTable[0].seriesName}}</span>
              <span>型号：{{quoteCollectTable[0].proModel}}</span>
              <span>订货号：{{quoteCollectTable[0].proOrdernum}}</span>
              <span>产品名称：{{quoteCollectTable[0].proName}}</span>
              <span>产品面价：{{quoteCollectTable[0].proPrice | toFixed}}</span>
            </div>
            <el-table
              ref="multipleTable"
              :data="quoteCollectTable"
              tooltip-effect="dark"
              :max-height="tableHeight-40"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
              border
            >
              <el-table-column
                prop="suName"
                label="供应商"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="proUnit"
                label="最小单位"
              ></el-table-column>
              <el-table-column
                prop="stockCount"
                label="库存数量"
              >
                <template slot-scope="scope">{{scope.row.stockCount===null?'0':scope.row.stockCount}}</template>
              </el-table-column>
              <el-table-column
                prop="supPrice"
                label="采购单价"
              >
                <template slot-scope="scope">{{scope.row.supPrice | priceFilterNum}}</template>
              </el-table-column>
              <el-table-column
                prop="extype"
                label="类型"
              ></el-table-column>
              <el-table-column
                prop="extime"
                label="货期"
              ></el-table-column>
              <el-table-column
                prop="expire"
                label="价格有效期"
                width="95px"
              >
                <template slot-scope="scope">{{scope.row.expire | dateFilterD}}</template>
              </el-table-column>
              <el-table-column
                prop="exstate"
                label="是否有效"
              >
                <template slot-scope="scope">{{scope.row.exstate===0?'无效':'有效'}}</template>
              </el-table-column>
              <el-table-column
                prop="source"
                label="来源"
              ></el-table-column>
              <el-table-column
                prop="createUser"
                label="添加人"
              ></el-table-column>
              <el-table-column
                prop="createDate"
                label="添加时间"
                width="130"
              >
                <template slot-scope="scope">{{scope.row.createDate| dateFilterL}}</template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <pagination
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </div>
        <div
          v-else
          style="background-color: #fff;display: flex;justify-content: center;align-items: center;"
          :style="{height: tableHeight + 'px'}"
        >暂无匹配数据，请重新输入搜索条件
        </div>
      </div>
      <div
        v-else
        style="background-color: #fff;display: flex;justify-content: center;align-items: center;"
        :style="{height: tableHeight + 'px'}"
      >请通过型号/订货号搜索查询报价的数据
      </div>
    </div>
  </div>
</template>
<script>
import { quoteCollectList, emptyList } from './utils/data'
import {
  queryBySupplierOfferSummary,
  queryAllByChargeStaffId,
  deleteSupplierOffer, queryProductByName, querySupplierByPro
} from '@/api/supplier/supplierManage'
import pagination from '@/components/pagination'
import { isSuccess } from '@/util/tool'

export default {
  components: {
    pagination
  },
  data () {
    return {
      emptyList,
      form: {},
      radio: '',
      nosearch: false,
      disableDialog: false,
      tableHeight: window.innerHeight - 320,
      queryParams: {
        column: 'suName',
        value: ''
      },
      quoteCollectList: [],
      quoteCollectTable: [],
      principalList: [], // 负责人
      total: 0,
      currentPage: 1, // 当前页
      pageSize: 30, // 分页页数
      loadingTable: false,
      serchList: [],
      suId: '',
      options: [],
      loading: false,
      superVal: ''
    }
  },
  watch: {
    queryParams (val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'suName')
      }
    }
  },
  directives: {
    'el-select-loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          '.el-select-dropdown .el-select-dropdown__wrap'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  created () {
    this.quoteCollectList = quoteCollectList
    // this.getList()
  },
  methods: {
    // 报价列表
    getList () {
      this.loadingTable = true
      this.nosearch = true
      querySupplierByPro(this.currentPage, this.pageSize, (this.queryParams.value || 0)).then(
        res => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.quoteCollectTable = res.data.obj.records
            this.total = res.data.obj.total
          } else {
            this.$message.error(res.data.msg)
          }
        }
      )
    },
    // 选择搜索条件
    changeColumn (val) {
      delete this.queryParams.value
    },
    // 获取负责人
    getQueryAllByChargeStaffId () {
      queryAllByChargeStaffId().then(res => {
        if (res.data.code === 200) {
          this.principalList = res.data.obj
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 导入
    onToLead (row) {
      this.$refs.quoteLeadInRef.onLeadIn(row.suId)
    },
    // 重置
    onReset () {
      this.serchList = []
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    onSearch () {
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.serchList = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 供应商详情
    onEdit (row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    // 操作日志
    onOperationLog (row) {
      this.$refs.operationLogRefs.onOperation(row.suId)
    },
    // 查看明细
    onSeeDetail (row) {
      this.$router.push({
        path: '/crm/supplier/quoteDetail',
        query: { id: row.suId }
      })
    },
    // 清空报价提示框
    getEmpty (row) {
      this.suId = row.suId
      this.disableDialog = true
    },
    // 确定清空报价
    onSubmit (row) {
      console.log(this.form.state)
      if (this.form.state) {
        deleteSupplierOffer(this.suId, this.form.state).then(res => {
          if (res.data.code === 200) {
            this.$message.success('清空成功')
            this.disableDialog = false
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('请选择报价类型')
      }
    },

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 分页页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 分页码数
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    // 滚动加载更多
    loadmore () {
      this.currentPage++
      this.onchange(this.superVal)
    },
    onchange(query) {
      queryProductByName(this.currentPage, this.pageSize, query).then(res => {
        if (isSuccess(res)) {
          if (this.currentPage === 1) {
            this.options = res.data.obj.records
          } else {
            const arrList = res.data.obj.records
            this.options = this.options.concat(arrList)
          }
        }
      })
    },
    remoteMethod (query) {
      this.superVal = query
      if (!query) {
        this.options = []
        return
      }
      this.currentPage = 1
      this.onchange(query)
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
  .supplier-list {
    .supplier-list-form {
      padding: 10px 30px;
    }
  }

  .wft > span {
    padding-right: 20px;
  }
</style>
